import {
  faChartLine,
  faMapMarkerAlt,
  faUtensils,
  faMobileAlt,
  faTooth,
  faUserMd,
  faShieldAlt,
  faLaptopMedical,
  faFileInvoice,
  faMoneyBillWave,
  faUniversity,
  faClock,
  faStar,
  faCode,
  faRocket,
  faGlobe,
  faLock,
  faBolt,
  faHeart,
  faLeaf,
} from '@fortawesome/free-solid-svg-icons'

const iconMap = {
  faChartLine,
  faMapMarkerAlt,
  faUtensils,
  faMobileAlt,
  faTooth,
  faUserMd,
  faShieldAlt,
  faLaptopMedical,
  faFileInvoice,
  faMoneyBillWave,
  faUniversity,
  faClock,
  faStar,
  faCode,
  faRocket,
  faGlobe,
  faLock,
  faBolt,
  faHeart,
  faLeaf,
}

export const getIcon = (iconName) => iconMap[iconName] || faStar

export default iconMap
